import { Container, CssBaseline } from '@mui/material';
import { useParams } from 'react-router-dom';
import ClientRates from './ClientRates';
import useGmdUserInfo from '../../../hooks/gmdUserInfo';

const ClientRatesTabContainer = () => {
  const { canEditRates, canAddRates, canDeleteRates } = useGmdUserInfo();
  let { tenantId } = useParams();
  if (!tenantId) {
    return <div>Missing platform client id</div>;
  }

  return (
    <Container component="main">
      <CssBaseline />
      <ClientRates
        tenantId={tenantId}
        allowEdits={canEditRates}
        showAddButton={canAddRates}
        allowDelete={canDeleteRates}
      />
    </Container>
  );
};

export default ClientRatesTabContainer;
